import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import DashBoard from '@/components/DashBoard'
import ResearchField from '@/components/ResearchField'
import ResearchPerform from '@/components/ResearchPerform'

import ResearchResult from '@/components/ResearchResult'
import DataSystem from '@/components/DataSystem'
import DataWise from '@/components/DataWise'
import NoticeActive from '@/components/NoticeActive'
import NoticeNews from '@/components/NoticeNews'
import CenterPurpose from '@/components/CenterPurpose'
import CenterHistory from '@/components/CenterHistory'
import CenterPerson from '@/components/CenterPerson'
import CenterLocation from '@/components/CenterLocation'
import CenterCI from '@/components/CenterCI'
import ResearchWrite from '@/components/ResearchWrite'
import NoticeWrite from '@/components/NoticeWrite'
import NoticeDetail from '@/components/NoticeDetail'

import Login from '@/components/Login'

Vue.use(Router)

export default new Router(
  {
    //mode : 'history',
    routes: [
      { path: '/',      name: 'Home',  component: Home  , redirect:'/dashboard',
        children: [
          { path: 'dashboard', name: 'dashboard' ,component: DashBoard ,
            beforeEnter:(to, from, next) => {
              console.log("XX beforeEnter : " + to);
              next();
            }
          },
          { path: 'researchfield',  name: 'researchfield',  component: ResearchField ,props:true},
          { path: 'researchperform',  name: 'researchperform',  component: ResearchPerform },
          { path: 'researchwrite',  name: 'researchwrite',  component: ResearchWrite ,props:true},
          { path: 'researchresult',  name: 'researchresult',  component: ResearchResult },
          { path: 'datasystem',  name: 'datasystem',  component: DataSystem },
          { path: 'datawise',  name: 'datawise',  component: DataWise },
          { path: 'noticeactive',  name: 'noticeactive',  component: NoticeActive },
          { path: 'noticenews',  name: 'noticenews',  component: NoticeNews },
          { path: 'centerpurpose',  name: 'centerpurpose',  component: CenterPurpose },
          { path: 'centerhistory',  name: 'centerhistory',  component: CenterHistory },
          { path: 'centerperson',  name: 'centerperson',  component: CenterPerson },
          { path: 'centerlocation',  name: 'centerlocation',  component: CenterLocation },
          { path: 'centerCI',  name: 'centerCI',  component: CenterCI },
          { path: 'noticewrite',  name: 'noticewrite',  component: NoticeWrite ,props:true},
          { path: 'noticedetail',  name: 'noticedetail',  component: NoticeDetail , props:true}
        ]
      },
      {path: '/hello', name: 'hello', component: DashBoard},
      {path: '/login', name: 'login', component: Login},
    ]
  })



// WEBPACK FOOTER //
// ./src/router/index.js